import React, { useState, useEffect, useRef } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { marked } from "marked";
import "./ChatContainer.css";
import { sendChatReaction, getReactionData } from "../api";
import {
  FileText, Shield, Factory, Wrench, Users, FileSearch, FileDigit, Download, FolderOpen, Database, FileUp, Image, Plus, Mic, MicOff, Send, Sun, Moon, ChevronDown, X, XCircle, Copy, ThumbsUp, ThumbsDown, RotateCw, MessageSquare, Search, Settings, User, /* Building2 - removed, */ Menu, HelpCircle, AlertCircle
} from "lucide-react";

// Destructure all required props at the top
function ChatContainer(props) {
        // --- State, refs, and handlers (single source of truth) ---
        // Refs
        const fileInputRef = useRef(null);
        const imageInputRef = useRef(null);
        const attachBtnRef = useRef(null);
        const attachDropdownRef = useRef(null);
        const mobileModeSelectorRef = useRef(null);
        /* COMMENTED OUT: Department selector refs
        const mobileDeptSelectorRef = useRef(null);
        const departmentDropdownRef = useRef(null);
        */
        const messagesEndRef = useRef(null);
        const timerRef = useRef(null);
        const loadedChatRef = useRef({ id: null, hasFullConv: false });
        const isNewChatFromSendRef = useRef(false);
        const textareaRef = useRef(null);
        const messagesRef = useRef([]);

        // State
        // Use selectedRecentChat from props
        const selectedRecentChat = props.selectedRecentChat;
        const [messages, setMessages] = useState([]);
        const [isTyping, setIsTyping] = useState(false);
        const [message, setMessage] = useState("");
        const [uploadedFiles, setUploadedFiles] = useState([]);
        const [showMobileMenu, setShowMobileMenu] = useState(false);
        const [showMobileChatModeDropdown, setShowMobileChatModeDropdown] = useState(false);
        const [showChatModeDropdown, setShowChatModeDropdown] = useState(false);
        /* COMMENTED OUT: Department selector state
        const [showDepartmentDropdown, setShowDepartmentDropdown] = useState(false);
        const [showMobileDepartmentDropdown, setShowMobileDepartmentDropdown] = useState(false);
        */
        const [showAttachDropdown, setShowAttachDropdown] = useState(false);
        const [showAttachText, setShowAttachText] = useState(false);
        const [showAttachComingSoon, setShowAttachComingSoon] = useState(false);
        const [isRecording, setIsRecording] = useState(false);
        const [sidebarCollapsed] = useState(false);
        const [lightMode, setLightMode] = useState(() => {
          // Always read localStorage first — this is updated by onThemeChange every toggle
          const t = localStorage.getItem('theme') || props.settings?.theme || 'light';
          return t !== 'dark';
        });
        const [environment] = useState("chat");
        // Use chatMode from props directly (like new-ui reference)
        const propChatMode = props.chatMode || "";
        const [selectedDepartment, setSelectedDepartment] = useState(null);
        /* COMMENTED OUT: Department search term state
        const [departmentSearchTerm, setDepartmentSearchTerm] = useState("");
        const [mobileDepartmentSearchTerm, setMobileDepartmentSearchTerm] = useState("");
        */
        const [hasStartedChatting, setHasStartedChatting] = useState(false);
        const [mediaRecorder, setMediaRecorder] = useState(null);
        const [audioChunks, setAudioChunks] = useState([]);
        // Removed unused state: recordingStatus, audioPermission
        const [recordingTimer, setRecordingTimer] = useState(0);
        const [messageFeedback, setMessageFeedback] = useState({});
        const [showTeaAccessDenied, setShowTeaAccessDenied] = useState(false);
        const [showSpaAccessDenied, setShowSpaAccessDenied] = useState(false);
        const [userName, setUserName] = useState(() => {
          // Parse first name from SSO displayName e.g. "Ore, Juwon (CSD/219C) NLNGPHC"
          const raw = (typeof window !== 'undefined' && localStorage.getItem('displayName')) || "";
          if (!raw) return "";
          // Strip everything from '(' onward, then split on comma
          const namePart = raw.split('(')[0].trim(); // "Ore, Juwon"
          const parts = namePart.split(',');
          if (parts.length >= 2) {
            // "Ore, Juwon" → first name is the part after the comma
            return parts[1].trim().split(' ')[0]; // "Juwon"
          }
          // No comma — just return the first word
          return namePart.split(' ')[0];
        });
        // Removed unused state: initialized
        const DEFAULT_CHAT_MODE = "QMS";

        // Use handlers from props
        const onChangeChatMode = props.onChangeChatMode;
        /* COMMENTED OUT: Department change handler
        const onDepartmentChange = props.onDepartmentChange;
        */
        const onNavigate = props.onNavigate;
        const onSettingsClick = props.onSettingsClick;
        const onStartChat = props.onStartChat;
        const onUpdateChatTitle = props.onUpdateChatTitle;
      // Removed duplicate/unused helper functions and state declarations
    // --- BEGIN: Add all missing variables, refs, and stub functions ---
    // Refs
    // Removed duplicate/unused refs, state, and stub functions

    // --- END: Add all missing variables, refs, and stub functions ---
  // Local state for variables that are not props
  // Removed duplicate/unused state declarations

  // Removed duplicate/unused state and refs

  // Default chat mode - explicitly set to QMS AI
  // NOTE: Chat loading is handled by the useEffect near line ~535 which
  // reads selectedRecentChat.fullConversation set by App.jsx openChat.
  // Do NOT call onOpenChat here — it would create an infinite loop.

  // ...existing code...
  // Properly declare the departments array with full names
  const departments = React.useMemo(() => [
    { acronym: "CMA", name: "CMA", fullName: "Commercial Contract Management and Adminstration" },
    { acronym: "CMB", name: "CMB", fullName: "Commercial Business Services" },
    { acronym: "CMP", name: "CMP", fullName: "Price, Portfolio and Risk Management" },
    { acronym: "CMR", name: "CMR", fullName: "Commercial Market Research and Strategy" },
    { acronym: "CMM", name: "CMM", fullName: "Marketing and Business Development" },
    { acronym: "CMS", name: "CMS", fullName: "Commercial Shipping" },
    { acronym: "CSS", name: "CSS", fullName: "Corporate Services Security" },
    { acronym: "CSL", name: "CSL", fullName: "Corporate Services Logistics" },
    { acronym: "LOF", name: "LOF", fullName: "London Liaison Office" },
    { acronym: "CSD", name: "CSD", fullName: "Digital and Innovation" },
    { acronym: "CSI", name: "CSI", fullName: "Corporate Services Information and Management Technology" },
    { acronym: "CSE", name: "CSE", fullName: "Corporate Services Estates" },
    { acronym: "SGA", name: "SGA", fullName: "Shipping, Governance and Assurance" },
    { acronym: "BIM", name: "BIM", fullName: "Business Improvement" },
    { acronym: "ERC", name: "ERC", fullName: "External Relations and Community" },
    { acronym: "ERN", name: "ERN", fullName: "Nigerian Content Development" },
    { acronym: "ERG", name: "ERG", fullName: "Government Relations and Regulatory Compliance" },
    { acronym: "ERP", name: "ERP", fullName: "Corporate Communications and Public Affairs" },
    { acronym: "FNB", name: "FNB", fullName: "Finance Advisory and Business Support" },
    { acronym: "FNC", name: "FNC", fullName: "Finance Control" },
    { acronym: "FNL", name: "FNL", fullName: "Loans and Insurance" },
    { acronym: "FNS", name: "FNS", fullName: "Tax and Systems" },
    { acronym: "FNT", name: "FNT", fullName: "Financial Treasury" },
    { acronym: "FNR", name: "FNR", fullName: "Corporate Risk Management" },
    { acronym: "CMO", name: "CMO", fullName: "Corporate Medical Services" },
    { acronym: "HRE", name: "HRE", fullName: "Employee Relations, Policies and Services" },
    { acronym: "HRL", name: "HRL", fullName: "Learning & Knowledge Management" },
    { acronym: "HRO", name: "HRO", fullName: "HR Operations" },
    { acronym: "HRT", name: "HRT", fullName: "Talent Management and Recruitment" },
    { acronym: "LGC", name: "LGC", fullName: "Legal Governance and Compliance" },
    { acronym: "LGS", name: "LGS", fullName: "Legal Services" },
    { acronym: "LGT", name: "LGT", fullName: "Legal Transactions" },
    { acronym: "BI", name: "BI", fullName: "Business Integrity" },
    { acronym: "HSE", name: "HSE", fullName: "Health, Safety and Environment" },
    { acronym: "ECO", name: "ECO", fullName: "Expansion Coordination" },
    { acronym: "CPM", name: "CPM", fullName: "Contracts, Procurement & Materials" },
    { acronym: "CPL", name: "CPL", fullName: "Corporate Planning" },
    { acronym: "CAA", name: "CAA", fullName: "Corporate Audit and Assurance" },
    { acronym: "PC", name: "PC", fullName: "Production Units A/B/C" },
    { acronym: "PDE", name: "PDE", fullName: "Production Excellence" },
    { acronym: "PG", name: "PG", fullName: "Pipeline Asset and Gas Supply" },
    { acronym: "PI", name: "PI", fullName: "Plant Integrity Assurance" },
    { acronym: "PM", name: "PM", fullName: "Production Maintenance" },
    { acronym: "PO", name: "PO", fullName: "Production Operations" },
    { acronym: "PS", name: "PS", fullName: "Production Support" },
    { acronym: "PT", name: "PT", fullName: "Production Units D&E" },
    { acronym: "TE", name: "TE", fullName: "Corporate Engineering" },
    { acronym: "TC", name: "TC", fullName: "Technical Services Coordination" },
    { acronym: "TF", name: "TF", fullName: "Front End Development and Technical Interface" },
    { acronym: "TP", name: "TP", fullName: "Project Delivery" },
    { acronym: "CT", name: "CT", fullName: "Corporate Transformation" },
    { acronym: "CTF", name: "CTF", fullName: "Future Opportunities and ESG" },
    { acronym: "CTA", name: "CTA", fullName: "Corporate Transformation Advisor" },
    { acronym: "CTM", name: "CTM", fullName: "Transformation Management of Change and Comms" },
    { acronym: "CTE", name: "CTE", fullName: "Energy Transition" },
  ], []);

  const chatModes = React.useMemo(() => [
    {
      id: "qms",
      name: "QMS",
      icon: <FileText size={18} />,
      description: "Quality Management Assistant",
      warning:
        "AI can make mistakes. Please verify quality standards with QMS documentation.",
      environment: "chat",
      welcomeMessage: `# Chat with:  
**QMS**  

---

## Quality Management System Overview  

The NLNG Quality Management System ensures consistent quality in all operations. Key areas include:

1. **Quality Policy** - Commitment to meeting customer requirements and continuous improvement
2. **Quality Objectives** - Measurable goals aligned with the quality policy
3. **Document Control** - Management of quality documents and records
4. **Process Control** - Monitoring and measurement of processes
5. **Non-Conformance Management** - Handling of non-conforming products/services
6. **Corrective Actions** - Addressing root causes of non-conformances
7. **Internal Audits** - Regular assessment of QMS effectiveness
8. **Management Review** - Periodic review of QMS performance

### Applicable Standards:  
- **ISO 9001:2015** Quality Management Systems
- **NLNG Integrated Management System (IMS)**

Would you like more details about any specific aspect of the Quality Management System?`,
    },
    // ── CSI: hidden — uncomment when ready for production ──
    // {
    //   id: "csi",
    //   name: "CSI",
    //   icon: <Database size={18} />,
    //   description: "Corporate Services Information Management Technology Assistant",
    //   warning:
    //     "AI can make mistakes. Please verify critical information with CSI documentation.",
    //   environment: "csi",
    //   welcomeMessage: `# Chat with: CSI — Corporate Services Information Management Technology`,
    // },
    // ── END CSI ──
    {
      id: "hse",
      name: "HSE",
      icon: <Shield size={18} />,
      description: "Health and Safety Assistant",
      warning:
        "HSE Assistant can make mistakes. Please reach out to HSE support for critical tasks.",
      environment: "hse",
      welcomeMessage: `# Chat with:  
**HSE**  

---

## Health, Safety & Environment Assistant

I'm your AI assistant for Health, Safety & Environment. I can help you with:

- Safety protocols and procedures
- Risk assessments and JSA
- Incident reporting and investigation
- HSE documentation and compliance
- Emergency response procedures
- PPE requirements and guidelines

### How can I assist you today?

Feel free to ask me about any HSE-related topics, safety rules, or procedures.

**The 10 Life Saving Rules in HSE**

The NLNG Life Saving Rules are crucial for ensuring safety within the organization. Here are the 10 Life Saving Rules:

1. **Bypass Safety Controls** - Obtain authorization before overriding or disabling safety controls
2. **Confined Space** - Obtain authorization before entering a confined space
3. **Driving** - Follow safe driving practices, including seatbelt use and speed limits
4. **Energy Isolation** - Verify isolation and zero energy before working
5. **Hot Work** - Control flammables and obtain authorization before hot work
6. **Line of Fire** - Keep yourself and others out of the line of fire
7. **Safe Mechanical Lifting** - Plan lifting operations and stay clear of suspended loads
8. **Work Authorization** - Obtain authorization before starting work
9. **Working at Height** - Protect yourself against falls when working at height
10. **Stop Work Authority** - Stop work if you see an unsafe condition`,
    },
    {
      id: "po",
      name: "PO",
      icon: <Factory size={18} />,
      description: "Production Operations Assistant",
      warning:
        "PO Assistant can make mistakes. Please reach out to PO Support for critical tasks.",
      environment: "production",
      welcomeMessage: `# Chat with:  
**PO**  

---

## Production Operations Assistant

I'm your AI assistant for Production Operations. I can help you with:

- Production processes and procedures
- Equipment operation guidelines
- Maintenance schedules
- Quality control in production
- Safety protocols for production areas
- Production planning and scheduling

### How can I assist you today?

Feel free to ask me about any production-related topics or procedures.

**Production Operations Overview**

NLNG's production operations focus on:
- LNG production and processing
- Plant operations and monitoring
- Equipment maintenance and reliability
- Production efficiency and optimization
- Quality control and assurance
- Safety in production environments`,
    },
    // ── SPA: hidden — uncomment when ready for production ──
    // {
    //   id: "spa",
    //   name: "SPA",
    //   icon: <FileText size={18} />,
    //   description: "Sales & Purchase Agreement Assistant",
    //   warning:
    //     "SPA Assistant can make mistakes. Please reach out to SPA Support for critical tasks.",
    //   environment: "spa",
    //   welcomeMessage: `# Chat with: SPA — Sales & Purchase Agreement`,
    // },
    // ── END SPA ──
    {
      id: "tea",
      name: "TEA",
      icon: <Wrench size={18} />,
      description: "Corporate Engineering Assistant",
      warning:
        "TEA Assistant can make mistakes. Please reach out to TEA Support for critical tasks.",
      environment: "engineering",
      welcomeMessage: `# Chat with:  
**TEA**  

---

## Corporate Engineering Assistant

I'm your AI assistant for Corporate Engineering. I can help you with:

- Engineering standards and specifications
- Technical documentation
- Project engineering guidelines
- Design reviews and approvals
- Engineering change management
- Technical problem-solving

### How can I assist you today?

Feel free to ask me about any engineering-related topics or technical procedures.

**Engineering Standards at NLNG**

Our engineering practices follow:
- International standards (ISO, API, ASME)
- NLNG engineering specifications
- Industry best practices
- Safety and reliability requirements
- Environmental compliance
- Quality assurance protocols`,
    },
    {
      id: "hr",
      name: "ASK HR",
      icon: <Users size={18} />,
      description: "Employee Relations Assistant",
      warning:
        "ASK HR can make mistakes. Please reach out to HR Support for critical tasks.",
      environment: "hr",
      welcomeMessage: `# Chat with:  
**ASK HR**  

---

## Human Resources Assistant

I'm your AI assistant for Human Resources. I can help you with:

- HR policies and procedures
- Employee benefits information
- Leave and attendance guidelines
- Training and development
- Performance management
- Employee relations

### How can I assist you today?

Feel free to ask me about any HR-related topics or employee matters.

**HR Services at NLNG**

The HR department provides:
- Recruitment and onboarding
- Employee benefits administration
- Performance management
- Training and development programs
- Employee relations support
- Policy guidance and compliance`,
    },
  ], []);

  const environmentConfig = {
    chat: {
      title: `Welcome ${userName}!`,
      subtitle: "What would you like to know today?",
      placeholder: `Ask Nimi whatever you want...`,
      warning:
        "AI can make mistakes. Please verify quality standards with QMS documentation.",
    },
    csi: {
      title: `Welcome ${userName}!`,
      subtitle: "Ask me about CSI processes, systems, and documentation",
      placeholder: "Ask Nimi about CSI procedures, tools, or policies...",
      warning:
        "CSI Assistant can make mistakes. Please verify critical information with CSI documentation.",
    },
    hse: {
      title: `Welcome ${userName}!`,
      subtitle: "Ask me about Health, Safety, and Environment topics",
      placeholder: "Ask Nimi about HSE procedures, safety rules, or incidents...",
      warning:
        "HSE Assistant can make mistakes. Please reach out to HSE support for critical tasks.",
    },
    production: {
      title: `Welcome ${userName}!`,
      subtitle: "Ask me about Production Operations and processes",
      placeholder: "Ask Nimi about production procedures, equipment, or schedules...",
      warning:
        "AI can make mistakes. Please verify critical operations with your supervisor.",
    },
    spa: {
      title: `Welcome ${userName}!`,
      subtitle: "Ask me about Sales & Purchase Agreements",
      placeholder: "Ask Nimi about SPA terms, contract clauses, or commercial matters...",
      warning:
        "AI can make mistakes. Please verify contract details with the relevant legal or commercial team.",
    },
    engineering: {
      title: `Welcome ${userName}!`,
      subtitle: "Ask me about Engineering standards and technical documentation",
      placeholder: "Ask Nimi about engineering specifications, designs, or standards...",
      quickActions: [
        {
          icon: <FileSearch size={16} />,
          label: "Document Search",
          action: "documentSearch",
        },
        {
          icon: <FileDigit size={16} />,
          label: "Metadata Extractor",
          action: "metadataExtractor",
        },

      ],
      warning: "AI can make mistakes. Please consult engineering documentation for critical decisions.",
    },
    hr: {
      title: `Welcome to ASK HR, ${userName}!`,
      subtitle: "Ask me about HR policies, benefits, and employee matters",
      placeholder: "Ask about HR policies, benefits, or leave...",
      warning:
        "AI can make mistakes. Please contact HR department for confidential matters.",
    },
    documentSearch: {
      title: "Document Search",
      subtitle: "Search and analyze documents in the repository",
      placeholder: "Search for documents...",
      quickActions: [
        {
          icon: <FileSearch size={16} />,
          label: "Advanced search",
          action: "advancedSearch",
        },
        {
          icon: <FolderOpen size={16} />,
          label: "Browse folders",
          action: "browseFolders",
        },
        {
          icon: <Download size={16} />,
          label: "Export results",
          action: "exportResults",
        },
      ],
      warning:
        "Document search results are AI-generated. Please verify critical documents with source files.",
    },
    metadataExtractor: {
      title: "Metadata Extractor",
      subtitle: "Upload documents to extract metadata information",
      placeholder: "Ask about metadata extraction...",
      quickActions: [
        {
          icon: <FileDigit size={16} />,
          label: "Batch extract",
          action: "batchExtract",
        },
        {
          icon: <Database size={16} />,
          label: "Export metadata",
          action: "exportMetadata",
        },
        {
          icon: <FileUp size={16} />,
          label: "Upload files",
          action: "uploadFiles",
        },
      ],
      warning:
        "Metadata extraction is automated. Please verify extracted data for accuracy.",
    },
    exportData: {
      title: "Export Data",
      subtitle: "Export your data in various formats",
      placeholder: "Select data to export...",
      quickActions: [
        {
          icon: <FileText size={16} />,
          label: "Export as PDF",
          action: "exportPDF",
        },
        {
          icon: <FileText size={16} />,
          label: "Export as CSV",
          action: "exportCSV",
        },
        {
          icon: <FileText size={16} />,
          label: "Export as JSON",
          action: "exportJSON",
        },
      ],
      warning:
        "Export data feature is in beta. Please verify exported files for completeness.",
    },
  };

  // Get current chat mode - ensure it's always defined and defaults to QMS AI
  const currentChatMode = (() => {
    // If propChatMode is provided and valid, use it
    if (propChatMode) {
      const found = chatModes.find((mode) => mode.name === propChatMode);
      if (found) return found;
    }
    // Default to QMS AI
    return chatModes[0];
  })();

  // Determine which environment config to use
  const getCurrentEnvironmentConfig = () => {
    // If we're in a special environment (documentSearch, etc.), use that
    if (environment !== "chat") {
      return environmentConfig[environment] || environmentConfig.chat;
    }

    // If we're in a department, use the appropriate environment config based on department
    if (selectedDepartment) {
      const dept = departments.find((d) => d.acronym === selectedDepartment);
      if (dept) {
        if (dept.acronym === "HSE") return environmentConfig.hse;
        if (dept.acronym.includes("PO") || dept.acronym === "PG") return environmentConfig.production;
      }
      // All other departments stay on QMS config
      return environmentConfig.chat;
    }

    // Otherwise, use the chat mode's specific environment if available
    if (
      currentChatMode?.environment &&
      environmentConfig[currentChatMode.environment]
    ) {
      return environmentConfig[currentChatMode.environment];
    }

    // Default to chat config
    return environmentConfig.chat;
  };

  const currentConfig = getCurrentEnvironmentConfig();

  const getParamsTagForMode = (modeValue = "") => {
    const mode = (modeValue || "").toLowerCase();
    if (mode === "hse" || mode.includes("hse")) return "HSE_PARAMS";
    if (mode === "po" || mode.includes("po")) return "POS_PARAMS";
    if (mode === "spa" || mode.includes("spa")) return "CMM_PARAMS";
    if (mode === "csi" || mode.includes("csi")) return "CSI_PARAMS";
    return "QMS_PARAMS";
  };

  const getChatEndpointForMode = (modeValue = "") => {
    const mode = (modeValue || "").toLowerCase();
    if (mode === "hse" || mode.includes("hse")) return "/v1/api/hse/chat/";
    if (mode === "po" || mode.includes("po")) return "/v1/api/pos/chat/";
    if (mode === "spa" || mode.includes("spa")) return "/v1/api/cmm/achat/";
    if (mode === "csi" || mode.includes("csi")) return "/v1/api/csi/achat/";
    return "/v1/api/qms/achat/";
  };

  const isJsonEndpointForMode = (modeValue = "") => {
    const mode = (modeValue || "").toLowerCase();
    return mode.includes("hse") || mode.includes("po");
  };

  useEffect(() => {
    // Parse first name from SSO displayName e.g. "Ore, Juwon (CSD/219C) NLNGPHC"
    const raw = (typeof window !== 'undefined' && localStorage.getItem('displayName')) || "";
    if (!raw) return;
    const namePart = raw.split('(')[0].trim();
    const parts = namePart.split(',');
    const firstName = parts.length >= 2
      ? parts[1].trim().split(' ')[0]
      : namePart.split(' ')[0];
    setUserName(firstName);
  }, [onChangeChatMode, propChatMode, selectedRecentChat]);

  // Sync lightMode with global theme whenever it changes
  useEffect(() => {
    const t = props.settings?.theme || localStorage.getItem('theme') || 'light';
    setLightMode(t !== 'dark');
  }, [props.settings?.theme]);

  // TEA AI access control — check department when chat mode changes
  useEffect(() => {
    if (propChatMode === 'TEA') {
      const displayName = localStorage.getItem('displayName') || '';
      const deptMatch = displayName.match(/\(([^)]+)\)/);
      const deptCode = deptMatch ? deptMatch[1].toUpperCase() : '';
      const hasAccess = deptCode.startsWith('TEA') || deptCode.startsWith('CSD');
      if (!hasAccess) setShowTeaAccessDenied(true);
    } else {
      setShowTeaAccessDenied(false);
    }
  }, [propChatMode]);

  // SPA access control — only CSD, non-contract CMM staff, and non-contract CMB staff
  useEffect(() => {
    if (propChatMode === 'SPA') {
      const displayName = localStorage.getItem('displayName') || '';
      const deptMatch = displayName.match(/\(([^)]+)\)/);
      const refId = deptMatch ? deptMatch[1].toUpperCase() : '';
      const isCSD = refId.startsWith('CSD');
      const isCMM = refId.startsWith('CMM');
      const isCMB = refId.startsWith('CMB');
      // For CMM/CMB: check the part after '/' — if it contains 'C', they are contract staff → no access
      const slashIndex = refId.indexOf('/');
      const afterSlash = slashIndex !== -1 ? refId.slice(slashIndex + 1) : '';
      const isCMMContractor = isCMM && afterSlash.includes('C');
      const isCMBContractor = isCMB && afterSlash.includes('C');
      const hasAccess = isCSD || (isCMM && !isCMMContractor) || (isCMB && !isCMBContractor);
      if (!hasAccess) setShowSpaAccessDenied(true);
    } else {
      setShowSpaAccessDenied(false);
    }
  }, [propChatMode]);

  // Initialize with QMS AI as default and show welcome page
  useEffect(() => {
    // Set QMS AI as default if no chat mode is provided or if it's empty
    if (!propChatMode || propChatMode === "") {
      onChangeChatMode(DEFAULT_CHAT_MODE);
    }

    // Mark as initialized
    // Removed setInitialized (unused)
    // NOTE: Removed selectedRecentChat from dependency array because it caused the UI to reset
    // when a new chat was created during message send. The actual loading logic for
    // selectedRecentChat is handled in the separate useEffect hook below (line 587+)
  }, [onChangeChatMode, propChatMode]);

  // Clean up recording resources
  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
      if (mediaRecorder && mediaRecorder.state === 'recording') {
        mediaRecorder.stop();
      }
    };
  }, [mediaRecorder]);

  // Keep messagesRef in sync with messages state so the loading effect
  // can read current message count without it being a dependency
  useEffect(() => {
    messagesRef.current = messages;
  }, [messages]);

  // Effect to load recent chat when selected.
  // ONLY depends on selectedRecentChat — never on messages state directly.
  // We read messages via messagesRef to avoid the effect firing when messages change.
  useEffect(() => {
    const currentChatId = selectedRecentChat?.id;
    const hasFullConv = !!(selectedRecentChat?.fullConversation && selectedRecentChat.fullConversation.length > 0);
    const previousChatId = loadedChatRef.current.id;
    const currentMessages = messagesRef.current;

    // Smart guard: skip if we've already handled this exact state.
    // Allows re-running when fullConversation arrives for the same ID.
    if (
      previousChatId === currentChatId &&
      selectedRecentChat &&
      (loadedChatRef.current.hasFullConv || !hasFullConv)
    ) {
      return;
    }

    // Update ref with current state
    loadedChatRef.current = { id: currentChatId, hasFullConv };

    // If no chat is selected, reset UI to welcome
    if (!selectedRecentChat) {
      setSelectedDepartment(null);
      setHasStartedChatting(false);
      setMessages([]);
      return;
    }

    // Is this a switch to a completely different chat?
    const isSwitchingChats = !!previousChatId && previousChatId !== currentChatId;

    // If there are already messages in the current view, the user is mid-conversation.
    // NEVER reset them — this is the core guard that prevents flipping back to welcome.
    // Exception: if fullConversation data just arrived (hasFullConv=true), always restore it
    // even if there's a placeholder welcome message already shown.
    if (currentMessages.length > 0 && !isSwitchingChats && !hasFullConv) {
      return;
    }

    console.log("Loading recent chat:", selectedRecentChat.id, "| hasFullConv:", hasFullConv, "| switching:", isSwitchingChats);

    // If this chat has actual conversation history, restore it
    if (hasFullConv) {
      setMessages([]);
      setSelectedDepartment(null);
      setHasStartedChatting(true);

      const restoredMessages = selectedRecentChat.fullConversation.map((item, idx) => ({
        id: Date.now() + idx,
        backendMessageId: item.message_id || null,
        type: item.is_user ? "user" : "assistant",
        content: item.text || "",
        time: item.timestamp
          ? (() => { try { return new Date(item.timestamp).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }); } catch { return item.timestamp; } })()
          : new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
        environment: "chat",
      }));
      try {
        const savedSuggestions = localStorage.getItem(`chat_suggestions_${selectedRecentChat.id}`);
        if (savedSuggestions) {
          const parsed = JSON.parse(savedSuggestions);
          if (Array.isArray(parsed) && parsed.length > 0) {
            const lastBotIdx = restoredMessages.map(m => m.type).lastIndexOf('assistant');
            if (lastBotIdx !== -1) {
              restoredMessages[lastBotIdx] = { ...restoredMessages[lastBotIdx], furtherQuestions: parsed };
            }
          }
        }
      } catch (_) {}
      setMessages(restoredMessages);
      return;
    }

    // Fresh/empty chat — show welcome screen
    setSelectedDepartment(null);
    setHasStartedChatting(false);
    setMessages([]);

    {
      // Build a welcome assistant message based on chat context
      let formattedContent = selectedRecentChat.content;
      const matchingDept = departments.find(dept => selectedRecentChat.title.includes(dept.acronym));

      if (matchingDept) {
          setSelectedDepartment(matchingDept.acronym);
          formattedContent =
            formattedContent ||
            `# Chat with:  
**${matchingDept.name} Assistant**  

---

## Welcome to ${matchingDept.name} Department

I'm your AI assistant for the ${matchingDept.name} department. I can help you with:

- Department procedures and documentation
- Policy inquiries and compliance
- Process documentation and workflows
- Department-specific tools and systems
- Training materials and resources

### How can I assist you today?

Feel free to ask me about any ${matchingDept.name}-related topics, documents, or procedures.`;
        }
        // Check for QMS AI related content
        else if (
          selectedRecentChat.title.includes("QMS") ||
          selectedRecentChat.title.includes("Quality")
        ) {
          formattedContent = formattedContent || chatModes[0].welcomeMessage;
        }
        // If it's the first chat (HSE Rules), use the specific formatting
        else if (
          selectedRecentChat.id === 1 ||
          selectedRecentChat.title.includes("10 Life Saving")
        ) {
          formattedContent = formattedContent || chatModes[1].welcomeMessage;
        }
        // If it's the second chat (Project Safety Guidelines)
        else if (
          selectedRecentChat.id === 2 ||
          selectedRecentChat.title.includes("Project Safety")
        ) {
          formattedContent =
            formattedContent ||
            `**Project Safety Guidelines**

Project safety guidelines are essential for maintaining a safe work environment during construction and maintenance activities. Key areas include:

1. **Risk Assessment and Management**
   - Conduct Job Safety Analysis (JSA) before each task
   - Identify hazards and implement controls
   - Review and update risk assessments regularly

2. **Personal Protective Equipment (PPE) Requirements**
   - Hard hat, safety glasses, steel-toed boots (mandatory)
   - High-visibility vest for all site personnel
   - Task-specific PPE (gloves, respirators, fall protection)

3. **Safe Work Procedures**
   - Permit to Work system for high-risk activities
   - Lock-out/Tag-out procedures for energy isolation
   - Safe lifting and rigging practices

4. **Emergency Response Protocols**
   - Site-specific emergency procedures
   - Assembly points and evacuation routes
   - First aid and medical emergency response

5. **Regular Safety Audits and Inspections**
   - Daily site inspections by supervisors
   - Weekly safety walks by management
   - Monthly comprehensive safety audits

Would you like specific information about any of these areas?`;
        }

      const chatMessage = {
        id: Date.now(),
        type: "assistant",
        content: formattedContent,
        time: new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
        environment: "chat",
        department: matchingDept?.acronym || null,
      };
      setMessages([chatMessage]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRecentChat]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        attachDropdownRef.current &&
        !attachDropdownRef.current.contains(event.target) &&
        attachBtnRef.current &&
        !attachBtnRef.current.contains(event.target)
      ) {
        setShowAttachDropdown(false);
      }

      if (
        mobileModeSelectorRef.current &&
        !mobileModeSelectorRef.current.contains(event.target)
      ) {
        setShowMobileChatModeDropdown(false);
      }

      /* COMMENTED OUT: Close mobile department dropdown
      // Close mobile department dropdown when clicking outside
      if (
        mobileDeptSelectorRef.current &&
        !mobileDeptSelectorRef.current.contains(event.target)
      ) {
        setShowMobileDepartmentDropdown(false);
        setMobileDepartmentSearchTerm("");
      }
      */

      // Close chat mode dropdown when clicking outside
      if (
        !event.target.closest(".current-mode") &&
        !event.target.closest(".mode-dropdown")
      ) {
        setShowChatModeDropdown(false);
      }

      /* COMMENTED OUT: Close department dropdown
      // Close department dropdown when clicking outside
      if (
        departmentDropdownRef.current &&
        !departmentDropdownRef.current.contains(event.target)
      ) {
        setShowDepartmentDropdown(false);
        setDepartmentSearchTerm("");
      }
      */
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  /* COMMENTED OUT: Department selector functionality
  const handleDepartmentSelect = (dept) => {
    setShowDepartmentDropdown(false);
    setShowMobileDepartmentDropdown(false);
    setDepartmentSearchTerm("");
    setMobileDepartmentSearchTerm("");

    // HSE and PO switch to their own dedicated assistants
    if (dept.acronym === 'HSE') {
      if (typeof onChangeChatMode === 'function') onChangeChatMode('HSE');
      return;
    }
    if (dept.acronym === 'PO' || dept.acronym === 'PG') {
      if (typeof onChangeChatMode === 'function') onChangeChatMode('PO');
      return;
    }

    // All other departments: just update the dept value sent in API, keep QMS UI unchanged
    setSelectedDepartment(dept.acronym);
    console.log("Selected department:", dept);
    if (onDepartmentChange) {
      onDepartmentChange(dept);
    }
  };

  // Filter departments based on search term (for desktop)
  const filteredDepartments = departments.filter(
    (dept) =>
      dept.acronym.toLowerCase().includes(departmentSearchTerm.toLowerCase()) ||
      dept.name.toLowerCase().includes(departmentSearchTerm.toLowerCase()),
  );

  // Filter departments based on mobile search term
  const filteredMobileDepartments = departments.filter(
    (dept) =>
      dept.acronym
        .toLowerCase()
        .includes(mobileDepartmentSearchTerm.toLowerCase()) ||
      dept.name
        .toLowerCase()
        .includes(mobileDepartmentSearchTerm.toLowerCase()),
  );
  */

  const getWarningMessage = () => {
    if (currentChatMode?.warning) {
      return currentChatMode.warning;
    }
    return currentConfig.warning;
  };

  const getHeaderTitle = () => {
    // Check for special environments
    if (environment !== "chat") {
      switch (environment) {
        case "documentSearch":
          return "Document Search";
        case "metadataExtractor":
          return "Metadata Extractor";
        case "exportData":
          return "Export Data";
        default:
          return environment;
      }
    }

    // Return current chat mode name
    return currentChatMode?.name || DEFAULT_CHAT_MODE;
  };

  const getHeaderIcon = () => {
    // Check if we're in a department-specific chat
    if (selectedDepartment) {
      const dept = departments.find((d) => d.acronym === selectedDepartment);
      if (dept) {
        return dept.icon;
      }
    }

    // Check for special environments
    if (environment !== "chat") {
      switch (environment) {
        case "documentSearch":
          return <FileSearch size={20} />;
        case "metadataExtractor":
          return <FileDigit size={20} />;
        case "exportData":
          return <Download size={20} />;
        default:
          return <FileText size={20} />;
      }
    }

    // Return current chat mode icon
    return currentChatMode?.icon || <FileText size={20} />;
  };

  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, isTyping]);

  // Remove duplicate renderSuggestions and misplaced clipboard code

  // Clipboard copy handler
  const handleCopyMessage = (msgContent) => {
    if (!msgContent) return;
    navigator.clipboard
      .writeText(msgContent)
      .then(() => {
        console.log("Message copied to clipboard");
      })
      .catch((err) => {
        console.error("Failed to copy message:", err);
      });
  };

  const handleThumbsUp = async (messageId) => {
    setMessageFeedback(prev => ({
      ...prev,
      [messageId]: prev[messageId] === 'like' ? null : 'like',
    }));
    try {
      const conversationId = selectedRecentChat?.id;
      const user_id = localStorage.getItem('userId') || '1';
      const params_tag = getParamsTagForMode(propChatMode);
      
      await sendChatReaction(messageId, conversationId, user_id, 'like', params_tag);
    } catch (e) {
      // visual state already updated; API call is best-effort
      console.error('Error sending like reaction:', e);
    }
  };

  const handleThumbsDown = async (messageId) => {
    setMessageFeedback(prev => ({
      ...prev,
      [messageId]: prev[messageId] === 'dislike' ? null : 'dislike',
    }));
    try {
      const conversationId = selectedRecentChat?.id;
      const user_id = localStorage.getItem('userId') || '1';
      const params_tag = getParamsTagForMode(propChatMode);
      
      await sendChatReaction(messageId, conversationId, user_id, 'dislike', params_tag);
    } catch (e) {
      // visual state already updated; API call is best-effort
      console.error('Error sending dislike reaction:', e);
    }
  };

  // Load persisted reaction states whenever messages are set/changed
  useEffect(() => {
    const conversationId = selectedRecentChat?.id;
    if (!conversationId || !messages || messages.length === 0) return;

    const assistantMessages = messages.filter(m => m.type === 'assistant' && m.id);
    if (assistantMessages.length === 0) return;

    const user_id = localStorage.getItem('userId') || '1';
    const params_tag = getParamsTagForMode(propChatMode);

    // Fetch reaction state for each assistant message in parallel
    Promise.all(
      assistantMessages.map(async (msg) => {
        const reactionKey = msg.backendMessageId || msg.id;
        const reaction = await getReactionData(reactionKey, conversationId, user_id, params_tag);
        return { reactionKey, reaction };
      })
    ).then((results) => {
      const updates = {};
      results.forEach(({ reactionKey, reaction }) => {
        if (!reaction) return;
        if (reaction.like === 1) updates[reactionKey] = 'like';
        else if (reaction.dislike === 1) updates[reactionKey] = 'dislike';
        // like=0, dislike=0 → leave unset (no highlight)
      });
      if (Object.keys(updates).length > 0) {
        setMessageFeedback(prev => ({ ...prev, ...updates }));
      }
    }).catch(err => console.warn('Failed to load reaction states:', err));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messages, selectedRecentChat?.id]);

  const handleRefresh = async (messageId) => {
    const messageIndex = messages.findIndex((m) => m.id === messageId);
    const userMessageIndex = messageIndex > 0 ? messageIndex - 1 : -1;
    const userMessage = userMessageIndex >= 0 ? messages[userMessageIndex] : null;

    if (!userMessage || userMessage.type !== 'user') return;

    const conversationId = selectedRecentChat?.id;
    if (!conversationId) return;

    // Remove the old bot response and show typing indicator
    setMessages((prev) => prev.filter((m) => m.id !== messageId));
    setIsTyping(true);

    try {
      const mode = propChatMode || '';
      const endpoint = getChatEndpointForMode(mode);

      const user_id = localStorage.getItem('userId') || '1';
      const res = await fetch(
        `${process.env.REACT_APP_API_URL || 'https://webapp-python-nlng-bots-api-cuasbrg3h5cyewgm.westeurope-01.azurewebsites.net'}${endpoint}${conversationId}`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ user_id, user_query: userMessage.content }),
        }
      );
      if (!res.ok) throw new Error('API error');

      // HSE and PO return plain JSON; QMS, SPA, and CSI stream SSE tokens
      const isJsonEndpoint = isJsonEndpointForMode(mode);

      if (isJsonEndpoint) {
        // --- Plain JSON response (HSE / PO) ---
        const data = await res.json();
        const content = data.bot_response || '(No response)';
        const furtherQs = Array.isArray(data.futher_question) ? data.futher_question
          : Array.isArray(data.further_question) ? data.further_question
          : Array.isArray(data.questions) ? data.questions : [];
        const imgs = Array.isArray(data.images) ? data.images : [];
        const backendMsgId = data.message_id || null;
        setIsTyping(false);
        setMessages((prev) => [
          ...prev,
          {
            id: Date.now() + 1,
            backendMessageId: backendMsgId,
            type: 'assistant',
            content,
            isStreaming: false,
            furtherQuestions: furtherQs,
            images: imgs,
            time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
            environment,
            department: selectedDepartment,
          },
        ]);
      } else {
      // --- SSE Streaming for regenerate ---
      const streamingId = Date.now() + 1;
      setIsTyping(false);
      setMessages((prev) => [
        ...prev,
        {
          id: streamingId,
          type: 'assistant',
          content: '',
          isStreaming: true,
          time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
          environment,
          department: selectedDepartment,
        },
      ]);

      const reader = res.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';
      let streamedContent = '';
      let streamMetadata = null;

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n');
        buffer = lines.pop();
        for (const line of lines) {
          if (!line.startsWith('data: ')) continue;
          const jsonStr = line.slice(6).trim();
          if (!jsonStr) continue;
          try {
            const parsed = JSON.parse(jsonStr);
            if (parsed.token !== undefined) {
              streamedContent += parsed.token;
              const captured = streamedContent;
              setMessages((prev) =>
                prev.map((m) =>
                  m.id === streamingId ? { ...m, content: captured } : m
                )
              );
            } else if (parsed.metadata) {
              streamMetadata = parsed.metadata;
            }
          } catch (_) {}
        }
      }

      const finalContent = streamMetadata?.full_answer || streamedContent || '(No response)';
      const furtherQs = Array.isArray(streamMetadata?.questions) ? streamMetadata.questions : [];
      const imgs = Array.isArray(streamMetadata?.images) ? streamMetadata.images : [];
      setMessages((prev) =>
        prev.map((m) =>
          m.id === streamingId
            ? { ...m, content: finalContent, isStreaming: false, furtherQuestions: furtherQs, images: imgs }
            : m
        )
      );
      } // end SSE branch
    } catch (e) {
      setMessages((prev) => [
        ...prev,
        {
          id: Date.now() + 1,
          type: 'assistant',
          content: "Sorry, I couldn't regenerate that response. Please try again.",
          time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
          environment,
        },
      ]);
    }
    setIsTyping(false);
  };

  // Send message using backend handler
  const handleSend = async (customMessage = null) => {
    let messageToSend = "";
    if (customMessage !== null) {
      messageToSend =
        typeof customMessage === "string"
          ? customMessage
          : customMessage?.title ||
            customMessage?.text ||
            customMessage?.content ||
            "";
    } else {
      messageToSend = message || "";
    }
    if (!messageToSend.trim() && uploadedFiles.length === 0) {
      console.log("No message to send");
      return;
    }
    if (!hasStartedChatting) {
      setHasStartedChatting(true);
    }
    const userMessage = {
      id: Date.now(),
      type: "user",
      content:
        messageToSend ||
        (uploadedFiles.length > 0 ? "Sent files" : "Empty message"),
      time: new Date().toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      }),
      files: uploadedFiles.length > 0 ? [...uploadedFiles] : null,
      environment,
    };
    // Immediately show the user message — clear any welcome-only state first
    // so the user always sees their own question right away
    setMessages((prev) => {
      // Drop any pure-welcome placeholder messages (assistant messages with no real content)
      const filtered = prev.filter(
        (m) => !(m.type === 'assistant' && m._isWelcome)
      );
      return [...filtered, userMessage];
    });
    setMessage("");
    if (textareaRef.current) textareaRef.current.style.height = 'auto';
    setUploadedFiles([]);
    setIsTyping(true);

    // Determine conversation ID — auto-create if none exists
    let conversationId = selectedRecentChat?.id;
    if (!conversationId && typeof onStartChat === 'function') {
      try {
        isNewChatFromSendRef.current = true;
        const newChat = await onStartChat();
        conversationId = newChat?.id;
      } catch (e) {
        console.error('Failed to auto-create chat:', e);
      } finally {
        isNewChatFromSendRef.current = false;
      }
    }

    if (conversationId) {
      try {
        let department = selectedDepartment;
        const mode = propChatMode || '';
        const endpoint = getChatEndpointForMode(mode);
        if (!department || department === 'Department') department = null;
        const user_id = localStorage.getItem('userId') || '1';
        const res = await fetch(`${process.env.REACT_APP_API_URL || "https://webapp-python-nlng-bots-api-cuasbrg3h5cyewgm.westeurope-01.azurewebsites.net"}${endpoint}${conversationId}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ user_id, user_query: messageToSend, department })
        });
        if (!res.ok) throw new Error('API error');

        // HSE and PO return plain JSON; QMS, SPA, and CSI stream SSE tokens
        const isJsonEndpoint = isJsonEndpointForMode(mode);

        if (isJsonEndpoint) {
          // --- Plain JSON response (HSE / PO) ---
          const data = await res.json();
          const content = data.bot_response || '(No response)';
          const furtherQs = Array.isArray(data.futher_question) ? data.futher_question
            : Array.isArray(data.further_question) ? data.further_question
            : Array.isArray(data.questions) ? data.questions : [];
          const imgs = Array.isArray(data.images) ? data.images : [];
          const backendMsgId = data.message_id || null;
          setIsTyping(false);
          setMessages((prev) => [
            ...prev,
            {
              id: Date.now() + 1,
              backendMessageId: backendMsgId,
              type: 'assistant',
              content,
              isStreaming: false,
              furtherQuestions: furtherQs,
              images: imgs,
              time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
              environment,
              department: selectedDepartment,
            },
          ]);
          if (conversationId && furtherQs.length > 0) {
            try { localStorage.setItem(`chat_suggestions_${conversationId}`, JSON.stringify(furtherQs)); } catch (_) {}
          }
        } else {
        // --- SSE Streaming: insert placeholder message then fill tokens in real-time ---
        const streamingId = Date.now() + 1;
        setIsTyping(false);
        setMessages((prev) => [
          ...prev,
          {
            id: streamingId,
            type: 'assistant',
            content: '',
            isStreaming: true,
            time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
            environment,
            department: selectedDepartment,
          },
        ]);

        const reader = res.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';
        let streamedContent = '';
        let streamMetadata = null;

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          buffer += decoder.decode(value, { stream: true });
          const lines = buffer.split('\n');
          buffer = lines.pop(); // keep any incomplete trailing line
          for (const line of lines) {
            if (!line.startsWith('data: ')) continue;
            const jsonStr = line.slice(6).trim();
            if (!jsonStr) continue;
            try {
              const parsed = JSON.parse(jsonStr);
              if (parsed.token !== undefined) {
                streamedContent += parsed.token;
                const captured = streamedContent;
                setMessages((prev) =>
                  prev.map((m) =>
                    m.id === streamingId ? { ...m, content: captured } : m
                  )
                );
              } else if (parsed.metadata) {
                streamMetadata = parsed.metadata;
              }
            } catch (_) {}
          }
        }

        // Final update — swap streamed content for full_answer if present, clear streaming flag
        const finalContent = streamMetadata?.full_answer || streamedContent || '(No response)';
        const furtherQs = Array.isArray(streamMetadata?.questions) ? streamMetadata.questions : [];
        const imgs = Array.isArray(streamMetadata?.images) ? streamMetadata.images : [];
        setMessages((prev) =>
          prev.map((m) =>
            m.id === streamingId
              ? { ...m, content: finalContent, isStreaming: false, furtherQuestions: furtherQs, images: imgs }
              : m
          )
        );

        // Save furtherQuestions to localStorage so they can be restored when the chat is reopened
        if (conversationId && furtherQs.length > 0) {
          try { localStorage.setItem(`chat_suggestions_${conversationId}`, JSON.stringify(furtherQs)); } catch (_) {}
        }
        } // end SSE branch
        // Update the chat title in the sidebar after the very first user message
        if (!hasStartedChatting && conversationId && messageToSend.trim() && typeof onUpdateChatTitle === 'function') {
          const newTitle = messageToSend.trim().slice(0, 50);
          onUpdateChatTitle(conversationId, newTitle);
        }
      } catch (e) {
        setMessages((prev) => [
          ...prev,
          {
            id: Date.now() + 1,
            type: "assistant",
            content: "Sorry, there was an error sending your message.",
            time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
            environment,
            department: selectedDepartment,
          },
        ]);
      }
    } else {
      // No conversation could be created
      setMessages((prev) => [
        ...prev,
        {
          id: Date.now() + 1,
          type: "assistant",
          content: "Unable to start a conversation. Please try again.",
          time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
          environment,
        },
      ]);
    }
    setIsTyping(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const handleTextareaChange = (e) => {
    setMessage(e.target.value);
    // Auto-resize like ChatGPT — textarea grows with content up to max height
    e.target.style.height = 'auto';
    e.target.style.height = Math.min(e.target.scrollHeight, 200) + 'px';
  };

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    const newFiles = files.map((file) => ({
      id: Date.now() + Math.random(),
      name: file.name,
      size: file.size,
      type: file.type,
      url: URL.createObjectURL(file),
      environment,
    }));
    setUploadedFiles((prev) => [...prev, ...newFiles]);

    setShowAttachDropdown(false);
  };

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    const imageFiles = files.filter((file) => file.type.startsWith("image/"));
    const newFiles = imageFiles.map((file) => ({
      id: Date.now() + Math.random(),
      name: file.name,
      size: file.size,
      type: file.type,
      url: URL.createObjectURL(file),
      environment,
    }));
    setUploadedFiles((prev) => [...prev, ...newFiles]);

    setShowAttachDropdown(false);
  };

  const removeFile = (id) => {
    setUploadedFiles((prev) => prev.filter((file) => file.id !== id));
  };

  const ASK_HR_TEAMS_URL = 'https://teams.microsoft.com/l/app/?titleId=T_cc6bfa21-2766-a109-73c5-0ec1e1f90982';

  const handleChatModeSelect = (mode) => {
    // ASK HR opens the Teams app link instead of switching chat mode
    if (mode.name === 'ASK HR') {
      window.open(ASK_HR_TEAMS_URL, '_blank', 'noopener,noreferrer');
      setShowChatModeDropdown(false);
      setShowMobileChatModeDropdown(false);
      return;
    }
    if (typeof onChangeChatMode === 'function') {
      onChangeChatMode(mode.name);
    }
    setShowChatModeDropdown(false);
    setShowMobileChatModeDropdown(false);
    /* COMMENTED OUT: setShowMobileDepartmentDropdown(false); */
    setSelectedDepartment(null);
    setMessages([]);
    setHasStartedChatting(false);
    // Optionally clear selectedRecentChat if needed
    // setSelectedRecentChat(null);
    console.log("Selected chat mode:", mode.name);
  };

  const handleQuickAction = (action) => {
    if (
      action === "documentSearch" ||
      action === "metadataExtractor" ||
      action === "exportData"
    ) {
      onNavigate(action);
    } else {
      // For quick actions that are actual messages
      handleSend(action);
    }
  };

  const toggleRecording = async () => {
    if (!isRecording) {
      // Start recording
      try {
        // Request microphone permission
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        // Removed setAudioPermission (unused)
        
        // Create media recorder
        const recorder = new MediaRecorder(stream);
        setMediaRecorder(recorder);
        
        // Clear previous audio chunks
        setAudioChunks([]);
        
        // Handle data available event
        recorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            setAudioChunks((prev) => [...prev, event.data]);
          }
        };
        
        // Handle recording stop
        recorder.onstop = () => {
          const audioBlob = new Blob(audioChunks, { type: 'audio/webm' });
          
          // Stop the timer
          if (timerRef.current) {
            clearInterval(timerRef.current);
            setRecordingTimer(0);
          }
          
          // Convert speech to text using Web Speech API
          if ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window) {
            convertSpeechToText(audioBlob);
          } else {
            alert('Speech recognition is not supported in this browser. Your recording has been saved.');
          }
          
          // Stop all tracks to release microphone
          stream.getTracks().forEach(track => track.stop());
        };
        
        // Start recording
        recorder.start();
        setIsRecording(true);
        // Removed setRecordingStatus (unused)
        
        // Start timer
        timerRef.current = setInterval(() => {
          setRecordingTimer(prev => prev + 1);
        }, 1000);
        
        console.log('Recording started');
        
      } catch (error) {
        console.error('Error accessing microphone:', error);
        alert('Could not access microphone. Please check your permissions.');
        setIsRecording(false);
        // Removed setAudioPermission (unused)
      }
    } else {
      // Stop recording
      if (mediaRecorder && mediaRecorder.state !== 'inactive') {
        mediaRecorder.stop();
        setIsRecording(false);
        // Removed setRecordingStatus (unused)
        console.log('Recording stopped');
      }
    }
  };

  const convertSpeechToText = (audioBlob) => {
    // Using Web Speech API for real-time speech recognition
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    
    if (SpeechRecognition) {
      const recognition = new SpeechRecognition();
      recognition.continuous = false;
      recognition.interimResults = false;
      recognition.lang = 'en-US';
      recognition.maxAlternatives = 1;
      
      recognition.onstart = () => {
        console.log('Speech recognition started');
      };
      
      recognition.onresult = (event) => {
        const transcript = event.results[0][0].transcript;
        console.log('Recognized text:', transcript);
        
        // Set the recognized text to the message input
        setMessage(transcript);
        
        // Optionally auto-send after a short delay
        setTimeout(() => {
          if (transcript.trim()) {
            handleSend(transcript);
          }
        }, 500);
      };
      
      recognition.onerror = (event) => {
        console.error('Speech recognition error:', event.error);
        if (event.error === 'no-speech') {
          alert('No speech detected. Please try again.');
        } else {
          alert('Speech recognition failed. Please try again.');
        }
      };
      
      recognition.onend = () => {
        console.log('Speech recognition ended');
      };
      
      recognition.start();
    } else {
      alert('Speech recognition is not supported in this browser.');
    }
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const clearChat = () => {
    setMessages([]);
    setHasStartedChatting(false);
    setSelectedDepartment(null);
  };

  const handleAttachClick = () => {
    setShowAttachComingSoon(true);
  };

  const handleAttachFileClick = () => {
    fileInputRef.current.click();
    setShowAttachDropdown(false);
  };

  const handleAttachImageClick = () => {
    imageInputRef.current.click();
    setShowAttachDropdown(false);
  };

  const handleEnvironmentBack = () => {
    onNavigate("chat");
  };

  const shouldShowQuickActions = () => {
    // Only show quick actions on welcome page (not when chatting)
    return (
      !hasStartedChatting &&
      environment !== "documentSearch" &&
      environment !== "metadataExtractor" &&
      environment !== "exportData" &&
      currentConfig.quickActions &&
      currentConfig.quickActions.length > 0
    );
  };

  const isSendEnabled = () => {
    const hasMessage = message && message.trim().length > 0;
    const hasFiles = uploadedFiles.length > 0;
    return hasMessage || hasFiles;
  };

  const getCurrentDepartmentInfo = () => {
    if (selectedDepartment) {
      return departments.find((d) => d.acronym === selectedDepartment);
    }
    return null;
  };

  const currentDeptInfo = getCurrentDepartmentInfo();

  // Get welcome title based on current context
  const getWelcomeTitle = () => {
    return currentConfig.title;
  };

  // Get welcome subtitle based on current context
  const getWelcomeSubtitle = () => {
    return currentConfig.subtitle;
  };

  // Get placeholder text based on current context
  const getPlaceholderText = () => {
    return currentConfig.placeholder;
  };

  /* COMMENTED OUT: Department selector check function
  // Check if we should show department selector (only for QMS AI)
  const shouldShowDepartmentSelector = () => {
    return environment === "chat" && currentChatMode?.name === "QMS";
  };
  */

  // NEW FUNCTION: Check if input field should be shown
  const shouldShowInputField = () => {
    // For TEA, hide input field — TEA only shows a welcome/quick-actions screen
    if (currentChatMode?.name === "TEA") {
      return false;
    }
    // For all others, show input field
    return true;
  };

  // NEW FUNCTION: Check if we're in TEA AI mode
  const isTEAIMode = () => {
    return currentChatMode?.name === "TEA";
  };

  // Utility to convert markdown to plain text (for copy)
  const markdownToPlainText = (markdown) => {
    if (typeof markdown !== 'string') return '';
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = marked(markdown);
    return tempDiv.textContent || tempDiv.innerText || '';
  };

  // Render content as Markdown, converting raw <a> tags to markdown links
  const renderMessageContent = (content) => {
    if (typeof content !== 'string') return content;

    // Convert raw <a> tags to markdown-style [text](url)
    const anchorRegex = /<a\b[^>]*href=["']?([^"'\s>]+)?["']?[^>]*>(.*?)<\/a>/gi;
    const converted = content.replace(anchorRegex, (match, href, innerText) => {
      if (!href || href.trim() === '') return `${innerText}`;
      return `[${innerText}](${href})`;
    });

    // Custom link renderer so all links open in a new tab
    const LinkRenderer = ({ href, children }) => (
      <a href={href} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );

    return <ReactMarkdown remarkPlugins={[remarkGfm]} components={{ a: LinkRenderer }}>{converted}</ReactMarkdown>;
  };

  return (
    <div
      className={`chat-container ${sidebarCollapsed ? "sidebar-collapsed" : ""} ${lightMode ? "light-mode" : "dark-mode"} environment-${environment}`}
    >
      {/* TEA AI Access Denied Modal */}
      {showTeaAccessDenied && (
        <div className="tea-access-overlay">
          <div className="tea-access-modal">
            <div className="tea-access-icon">
              <Wrench size={44} />
            </div>
            <h2 className="tea-access-title">Access Restricted</h2>
            <p className="tea-access-body">
              <strong>TEA</strong> is only available to members of the{' '}
              <strong>TEA</strong> and <strong>CSD</strong> departments.
            </p>
            <p className="tea-access-contact">
              Please contact the <strong>TEA Department</strong> to request access.
            </p>
            <button
              className="tea-access-btn"
              onClick={() => {
                setShowTeaAccessDenied(false);
                if (typeof onChangeChatMode === 'function') onChangeChatMode('QMS');
              }}
            >
              Go Back
            </button>
          </div>
        </div>
      )}

      {/* SPA Access Denied Modal */}
      {showSpaAccessDenied && (
        <div className="tea-access-overlay">
          <div className="tea-access-modal">
            <div className="tea-access-icon">
              <FileText size={44} />
            </div>
            <h2 className="tea-access-title">Access Restricted</h2>
            <p className="tea-access-body">
              <strong>SPA</strong> is only available to members of the{' '}
              <strong>CMM</strong> and <strong>CMB</strong> departments.
            </p>
            <p className="tea-access-contact">
              Please contact the <strong>CMM Department</strong> to request access.
            </p>
            <button
              className="tea-access-btn"
              onClick={() => {
                setShowSpaAccessDenied(false);
                if (typeof onChangeChatMode === 'function') onChangeChatMode('QMS');
              }}
            >
              Go Back
            </button>
          </div>
        </div>
      )}

      {/* Attach — Coming Soon Modal */}
      {showAttachComingSoon && (
        <div className="attach-cs-overlay" onClick={() => setShowAttachComingSoon(false)}>
          <div className="attach-cs-modal" onClick={(e) => e.stopPropagation()}>
            <div className="attach-cs-icon">
              <span className="attach-cs-rocket">🚀</span>
            </div>
            <h2 className="attach-cs-title">Coming Soon</h2>
            <p className="attach-cs-subtitle">File &amp; Image Attachments</p>
            <p className="attach-cs-body">
              The ability to attach files and images is currently under development
              and will be available in an upcoming version of NIMI.
            </p>
            
            <button
              className="attach-cs-btn"
              onClick={() => setShowAttachComingSoon(false)}
            >
              Got it
            </button>
          </div>
        </div>
      )}

      {/* Mobile Header */}
      <div className="mobile-header">
        <button
          className="mobile-menu-btn"
          onClick={() => setShowMobileMenu(!showMobileMenu)}
        >
          <Menu size={20} />
        </button>

        <div className="mobile-title">
          {environment === "chat" ? (
            <div className="mobile-header-content">
              <div className="mobile-current-display">
                <>
                  <span className="mode-icon">{currentChatMode?.icon}</span>
                  <span className="mode-name">{currentChatMode?.name}</span>
                </>
              </div>
            </div>
          ) : (
            <div className="mobile-environment-header">
              <span className="mode-icon">{getHeaderIcon()}</span>
              <span className="mode-name">{getHeaderTitle()}</span>
            </div>
          )}
        </div>

        <div className="mobile-actions">
          {/* Chat Mode Hamburger Menu */}
          <div className="mobile-hamburger-menu" ref={mobileModeSelectorRef}>
            <button
              className="mobile-hamburger-btn"
              onClick={() =>
                setShowMobileChatModeDropdown(!showMobileChatModeDropdown)
              }
            >
              <span className="hamburger-dot"></span>
              <span className="hamburger-dot"></span>
              <span className="hamburger-dot"></span>
            </button>

            {showMobileChatModeDropdown && (
              <div className="mobile-hamburger-dropdown">
                <div className="hamburger-dropdown-header">
                  <span>Select Chat Mode</span>
                </div>
                {chatModes.map((mode) => (
                  <div
                    key={mode.id}
                    className={`hamburger-menu-item ${currentChatMode?.name === mode.name ? "selected" : ""}`}
                    onClick={() => {
                      handleChatModeSelect(mode);
                      setShowMobileChatModeDropdown(false);
                    }}
                  >
                    <span className="item-icon">{mode.icon}</span>
                    <div className="item-info">
                      <span className="item-name">{mode.name}</span>
                      <span className="item-description">
                        {mode.description}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Mobile Department Selector - Only show for QMS AI */}
          {/* COMMENTED OUT: Mobile department selector hidden
          {shouldShowDepartmentSelector() && (
            <div
              className="mobile-hamburger-menu"
              ref={mobileDeptSelectorRef}
            >
              <button
                className={`mobile-hamburger-btn dept-btn ${currentDeptInfo ? "department-selected" : ""}`}
                onClick={() =>
                  setShowMobileDepartmentDropdown(
                    !showMobileDepartmentDropdown,
                  )
                }
              >
                {currentDeptInfo ? (
                  <span className="dept-icon">{currentDeptInfo.icon}</span>
                ) : (
                  <Building2 size={18} />
                )}
              </button>

              {showMobileDepartmentDropdown && (
                <div className="mobile-hamburger-dropdown dept-dropdown">
                  <div className="hamburger-dropdown-header">
                    <span>Select Department</span>
                  </div>
                  <div className="department-search">
                    <input
                      type="text"
                      placeholder="Search department..."
                      className="dept-search-input"
                      value={mobileDepartmentSearchTerm}
                      onChange={(e) =>
                        setMobileDepartmentSearchTerm(e.target.value)
                      }
                      onClick={(e) => e.stopPropagation()}
                      autoFocus
                    />
                  </div>
                  <div className="hamburger-dept-list">
                    {filteredMobileDepartments.length > 0 ? (
                      filteredMobileDepartments.map((dept, index) => (
                        <div
                          key={index}
                          className={`hamburger-menu-item ${selectedDepartment === dept.acronym ? "selected" : ""}`}
                          onClick={() => handleDepartmentSelect(dept)}
                        >
                          <span className="item-icon"></span>
                          <div className="item-info">
                            <span className="item-name">{dept.acronym}</span>
                            <span className="item-description">
                              {dept.fullName}
                            </span>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="no-results">No departments found</div>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
          */}

          <button className="mobile-settings-btn" onClick={onSettingsClick}>
            <User size={20} />
          </button>
        </div>
      </div>

      {/* Top Header Bar */}
      <div className="top-header">
        <div className="header-left">
          {environment === "chat" ? (
            <div className="chat-mode-selector">
              <span className="chat-with-label">Chat with:</span>
              <div
                className="current-mode"
                onClick={() => setShowChatModeDropdown(!showChatModeDropdown)}
              >
                <>
                  <span className="mode-icon">{currentChatMode?.icon}</span>
                  <span className="mode-name">{currentChatMode?.name}</span>
                </>
                <ChevronDown
                  size={16}
                  className={`dropdown-icon ${showChatModeDropdown ? "rotated" : ""}`}
                />
              </div>

              {showChatModeDropdown && (
                <div className="mode-dropdown">
                  {chatModes.map((mode) => (
                    <div
                      key={mode.id}
                      className={`mode-option ${currentChatMode?.name === mode.name ? "selected" : ""}`}
                      onClick={() => handleChatModeSelect(mode)}
                    >
                      <span className="mode-option-icon">{mode.icon}</span>
                      <div className="mode-option-info">
                        <span className="mode-option-name">{mode.name}</span>
                        <span className="mode-option-description">
                          {mode.description}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Desktop Department Selector - Only show for QMS AI */}
              {/* COMMENTED OUT: Department selector hidden
              {shouldShowDepartmentSelector() && (
                <div
                  className="department-selector"
                  ref={departmentDropdownRef}
                >
                  <div
                    className={`current-department ${currentDeptInfo ? "department-selected" : ""}`}
                    onClick={() =>
                      setShowDepartmentDropdown(!showDepartmentDropdown)
                    }
                  >
                    {currentDeptInfo ? (
                      <>
                        <span className="dept-icon">
                          {currentDeptInfo.icon}
                        </span>
                        <span className="dept-name">
                          {currentDeptInfo.acronym}
                        </span>
                      </>
                    ) : (
                      <>
                        <span className="dept-icon">
                          <Building2 size={16} />
                        </span>
                        <span className="dept-name">Department</span>
                      </>
                    )}
                    <ChevronDown
                      size={16}
                      className={`dropdown-icon ${showDepartmentDropdown ? "rotated" : ""}`}
                    />
                  </div>

                  {showDepartmentDropdown && (
                    <div className="department-dropdown">
                      <div className="department-search">
                        <input
                          type="text"
                          placeholder="Search department..."
                          className="dept-search-input"
                          value={departmentSearchTerm}
                          onChange={(e) =>
                            setDepartmentSearchTerm(e.target.value)
                          }
                          onClick={(e) => e.stopPropagation()}
                          autoFocus
                        />
                      </div>
                      <div className="department-list">
                        {filteredDepartments.length > 0 ? (
                          filteredDepartments.map((dept, index) => (
                            <div
                              key={index}
                              className={`department-item ${selectedDepartment === dept.acronym ? "selected" : ""}`}
                              onClick={() => handleDepartmentSelect(dept)}
                            >
                              <span className="dept-icon"></span>
                              <div className="dept-info">
                                <span className="dept-acronym">
                                  {dept.acronym}
                                </span>
                                <span className="dept-fullname">
                                  {dept.fullName}
                                </span>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="no-results">No departments found</div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              )}
              */}
            </div>
          ) : (
            <div className="environment-header">
              <button
                className="back-to-chat-btn"
                onClick={handleEnvironmentBack}
              >
                <ChevronDown size={18} className="back-icon" />
                <span>Back to Chat</span>
              </button>
              <div className="environment-info">
                <span className="environment-icon">{getHeaderIcon()}</span>
                <span className="environment-name">{getHeaderTitle()}</span>
              </div>
            </div>
          )}
        </div>

        <div className="header-right">
          <span className="chat-with-label">{lightMode ? 'Light Mode' : 'Dark Mode'}:</span>
          <button
            className="header-btn light-mode-toggle"
            onClick={() => {
              const next = !lightMode;
              setLightMode(next);
              const theme = next ? 'light' : 'dark';
              localStorage.setItem('theme', theme);
              document.documentElement.setAttribute('data-theme', theme);
              if (props.onThemeChange) props.onThemeChange(theme);
            }}
            title={lightMode ? "Switch to Dark Mode" : "Switch to Light Mode"}
          >
            {lightMode ? <Moon size={18} /> : <Sun size={18} />}
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className={`chat-main ${hasStartedChatting ? "chat-active" : ""}`}>
        {!hasStartedChatting ? (
          <div
            className={`compact-welcome-container environment-${environment} ${isTEAIMode() ? "tea-mode" : ""}`}
          >
            <div className="compact-welcome-content">
              <h1 className="welcome-title">
                <span className="gradient-text">{getWelcomeTitle()}</span>
                {environment === "chat" && (
                  <span className="wave-animation"> 👋</span>
                )}
              </h1>
              <p className="welcome-subtitle">{getWelcomeSubtitle()}</p>

             {/**  {currentDeptInfo && (
                <div className="department-badge">
                  <span>{currentDeptInfo.name}</span>
                </div>
              )}*/}

              {environment !== "chat" && (
                <div className={`environment-badge ${environment}`}>
                  {getHeaderIcon()}
                  <span>{currentConfig.title}</span>
                </div>
              )}
            </div>

            {/* Recording Indicator */}
            {isRecording && shouldShowInputField() && (
              <div className="recording-indicator">
                <span className="recording-dot"></span>
                <span>Recording... {formatTime(recordingTimer)}</span>
                <button 
                  className="stop-recording-btn"
                  onClick={toggleRecording}
                  title="Stop recording"
                >
                  <X size={16} />
                </button>
              </div>
            )}

            {/* MODIFIED: Conditionally show input section based on chat mode */}
            {shouldShowInputField() ? (
              <>
                <div className="input-section">
                  <input
                    type="file"
                    ref={fileInputRef}
                    multiple
                    onChange={handleFileUpload}
                    style={{ display: "none" }}
                    accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,image/*"
                  />
                  <input
                    type="file"
                    ref={imageInputRef}
                    multiple
                    onChange={handleImageUpload}
                    style={{ display: "none" }}
                    accept="image/*"
                  />

                  <div className="input-wrapper">
                    {/* Text Input - Center */}
                    <textarea
                      ref={textareaRef}
                      placeholder={getPlaceholderText()}
                      value={message || ""}
                      onChange={handleTextareaChange}
                      onKeyPress={handleKeyPress}
                      className={`chat-input ${hasStartedChatting ? "chat-active-input" : ""}`}
                      rows="1"
                    />

                    {/* Attach Button - Left */}
                    <div className="attach-wrapper" ref={attachDropdownRef}>
                      <button
                        className={`attach-btn ${showAttachDropdown ? "active" : ""}`}
                        onClick={handleAttachClick}
                        onMouseEnter={() => setShowAttachText(true)}
                        onMouseLeave={() => setShowAttachText(false)}
                        ref={attachBtnRef}
                      >
                        <Plus size={20} className="attach-icon" />
                        <span
                          className={`attach-text ${showAttachText ? "visible" : ""}`}
                        >
                          Attach
                        </span>
                      </button>

                      {showAttachDropdown && (
                        <div className="attach-dropdown">
                          <div
                            className="attach-dropdown-item"
                            onClick={handleAttachFileClick}
                          >
                            <FileUp size={18} />
                            <span>Attach file</span>
                          </div>
                          <div
                            className="attach-dropdown-item"
                            onClick={handleAttachImageClick}
                          >
                            <Image size={18} />
                            <span>Add photo</span>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Action Buttons - Right (Mic & Send) */}
                    <div className="action-buttons">
                      <button
                        className={`mic-btn ${isRecording ? "recording" : ""}`}
                        onClick={toggleRecording}
                        title={isRecording ? "Stop recording" : "Start voice input"}
                      >
                        {isRecording ? <MicOff size={18} /> : <Mic size={18} />}
                      </button>

                      <button
                        className="send-icon-btn"
                        onClick={() => handleSend()}
                        disabled={!isSendEnabled()}
                        title="Send message"
                      >
                        <Send size={18} />
                      </button>
                    </div>
                  </div>
                </div>

                <div className={`warning-box-fused environment-${environment}`}>
                  <AlertCircle className="warning-icon" size={20} />
                  <span className="warning-text">{getWarningMessage()}</span>
                </div>
              </>
            ) : (
              /* TEA AI Mode - No input field, just quick actions */
              <>
                <div className="tea-mode-placeholder"></div>
              </>
            )}

            {/* Quick Actions - Always show for TEA AI and when conditions met */}
            {(shouldShowQuickActions() || isTEAIMode()) && (
              <>
                <div className="quick-actions-title">Quick actions</div>
                <div className="quick-actions-inline">
                  {(isTEAIMode() ? environmentConfig.engineering.quickActions : currentConfig.quickActions || []).map((action, index) => (
                    <button
                      key={index}
                      className="quick-action-small"
                      onClick={() => handleQuickAction(action.action)}
                    >
                      {action.icon}
                      <span>{action.label}</span>
                    </button>
                  ))}
                </div>
              </>
            )}
          </div>
        ) : (
          <>
            <div className="chat-messages active">
              {messages.map((msg) => (
                <div
                  key={msg.id}
                  className={`message ${msg.type} animate-fadeIn`}
                >
                  {msg.type === "user" && (
                    <div className="user-message">
                      {msg.files && msg.files.length > 0 && (
                        <div className="message-files">
                          {msg.files.map((file) => (
                            <div key={file.id} className="file-preview">
                              {file.type.startsWith("image/") ? (
                                <img
                                  src={file.url}
                                  alt={file.name}
                                  className="file-image"
                                />
                              ) : (
                                <div className="file-document">
                                  <FileUp size={20} />
                                  <span>{file.name}</span>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                      {msg.content && (
                        <div className="message-content">{msg.content}</div>
                      )}
                      {/*<div className="message-footer">
                         <span className="message-time">{msg.time}</span> 
                        <User size={16} className="user-avatar" />
                      </div>*/}
                    </div>
                  )}

                  {msg.type === "assistant" && (
                    <div className="assistant-message">
                      <div className="message-header">
                        <div className="assistant-avatar">
                          {msg.department ? (
                            departments.find(
                              (d) => d.acronym === msg.department,
                            )?.icon || <FileText size={18} />
                          ) : msg.environment === "documentSearch" ? (
                            <FileSearch size={18} />
                          ) : msg.environment === "metadataExtractor" ? (
                            <FileDigit size={18} />
                          ) : msg.environment === "exportData" ? (
                            <Download size={18} />
                          ) : (
                            currentChatMode?.icon
                          )}
                        </div>
                        <div className="assistant-info">
                          <span className="assistant-name">
                            {msg.department
                              ? `${departments.find((d) => d.acronym === msg.department)?.name} Assistant`
                              : msg.environment === "documentSearch"
                                ? "Document Search Assistant"
                                : msg.environment === "metadataExtractor"
                                  ? "Metadata Extractor Assistant"
                                  : msg.environment === "exportData"
                                    ? "Export Data Assistant"
                                    : currentChatMode?.name}
                          </span>
                         {/**  <span className="message-time">{msg.time}</span>*/}
                        </div>
                      </div>

                      <div
                        className="message-content markdown-formatted"
                      >
                        {renderMessageContent(msg.content)}
                        {msg.isStreaming && <span className="streaming-cursor" aria-hidden="true" />}
                      </div>



                      {/* Base64 images from bot response */}
                      {Array.isArray(msg.images) && msg.images.length > 0 && (
                        <div className="message-images">
                          {msg.images.map((img, idx) => (
                            <img
                              key={idx}
                              src={img.startsWith('data:') ? img : `data:image/png;base64,${img}`}
                              alt={`Bot visualization ${idx + 1}`}
                              className="bot-response-image"
                              style={{ maxWidth: '100%', borderRadius: '8px', marginTop: '8px' }}
                            />
                          ))}
                        </div>
                      )}

                      {msg.details &&
                        msg.details.map((detail, index) => (
                          <div key={index} className="message-detail">
                            {detail}
                          </div>
                        ))}

                      {/* Further questions as clickable cards */}
                      {props.settings?.enableSuggestions !== false && Array.isArray(msg.furtherQuestions) && msg.furtherQuestions.length > 0 && (
                        <div className="further-questions-cards">
                          <div className="further-questions-title">You might also be interested in:</div>
                          <div className="further-questions-row">
                            {msg.furtherQuestions.slice(0, 3).map((q, idx) => (
                              <div key={idx} className="further-question-card">
                                <button
                                  className="further-question-btn"
                                  onClick={() => handleSend(q)}
                                >
                                  {q}
                                </button>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      <div className="message-actions-icons">
                        <button
                          className="action-icon-btn"
                          title="Copy"
                          onClick={() => handleCopyMessage(markdownToPlainText(msg.content))}
                        >
                          <Copy size={16} />
                        </button>
                        <button
                          className="action-icon-btn"
                          title={messageFeedback[msg.backendMessageId || msg.id] === 'like' ? 'Remove like' : 'Thumbs Up'}
                          onClick={() => handleThumbsUp(msg.backendMessageId || msg.id)}
                          style={messageFeedback[msg.backendMessageId || msg.id] === 'like' ? { color: '#22c55e' } : {}}
                        >
                          <ThumbsUp size={16} />
                        </button>
                        <button
                          className="action-icon-btn"
                          title={messageFeedback[msg.backendMessageId || msg.id] === 'dislike' ? 'Remove dislike' : 'Thumbs Down'}
                          onClick={() => handleThumbsDown(msg.backendMessageId || msg.id)}
                          style={messageFeedback[msg.backendMessageId || msg.id] === 'dislike' ? { color: '#ef4444' } : {}}
                        >
                          <ThumbsDown size={16} />
                        </button>
                        <button
                          className="action-icon-btn"
                          title="Regenerate response"
                          onClick={() => handleRefresh(msg.id)}
                        >
                          <RotateCw size={16} />
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              ))}



              {isTyping && props.settings?.typingIndicators !== false && (
                <div className="typing-indicator">
                  <div className="assistant-avatar">
                    {currentDeptInfo ? (
                      currentDeptInfo.icon
                    ) : environment === "documentSearch" ? (
                      <FileSearch size={18} />
                    ) : environment === "metadataExtractor" ? (
                      <FileDigit size={18} />
                    ) : environment === "exportData" ? (
                      <Download size={18} />
                    ) : (
                      currentChatMode?.icon
                    )}
                  </div>
                  <div className="typing-content">
                    <div className="typing-text">
                      {currentDeptInfo
                        ? `${currentDeptInfo.name} Assistant`
                        : environment === "documentSearch"
                          ? "Document Search Assistant"
                          : environment === "metadataExtractor"
                            ? "Metadata Extractor Assistant"
                            : environment === "exportData"
                              ? "Export Data Assistant"
                              : "Nimi"
                      } is thinking...
                    </div>
                    <div className="typing-dots">
                      <div className="dot animate-typing"></div>
                      <div
                        className="dot animate-typing"
                        style={{ animationDelay: "0.2s" }}
                      ></div>
                      <div
                        className="dot animate-typing"
                        style={{ animationDelay: "0.4s" }}
                      ></div>
                    </div>
                  </div>
                </div>
              )}

              <div ref={messagesEndRef} className="scroll-anchor" />
            </div>

            {uploadedFiles.length > 0 && (
              <div className="upload-preview animate-slideInUp">
                <div className="upload-preview-header">
                  <span>Attached Files ({uploadedFiles.length})</span>
                  <button
                    className="clear-all-btn"
                    onClick={() => setUploadedFiles([])}
                  >
                    <XCircle size={16} /> Clear All
                  </button>
                </div>
                <div className="upload-preview-grid">
                  {uploadedFiles.map((file) => (
                    <div key={file.id} className="uploaded-file">
                      {file.type.startsWith("image/") ? (
                        <div className="file-thumbnail">
                          <img src={file.url} alt={file.name} />
                          <span className="file-name">{file.name}</span>
                        </div>
                      ) : (
                        <div className="file-info">
                          <FileUp size={20} className="file-icon" />
                          <div className="file-details">
                            <span className="file-name">{file.name}</span>
                            <span className="file-size">
                              {(file.size / 1024 / 1024).toFixed(2)} MB
                            </span>
                          </div>
                        </div>
                      )}
                      <button
                        className="remove-file-btn"
                        onClick={() => removeFile(file.id)}
                      >
                        <X size={14} />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Recording Indicator for chat active state - Only show when input field is enabled */}
            {isRecording && shouldShowInputField() && (
              <div className="recording-indicator">
                <span className="recording-dot"></span>
                <span>Recording... {formatTime(recordingTimer)}</span>
                <button 
                  className="stop-recording-btn"
                  onClick={toggleRecording}
                  title="Stop recording"
                >
                  <X size={16} />
                </button>
              </div>
            )}

            {/* MODIFIED: Conditionally show input section based on chat mode */}
            {shouldShowInputField() && (
              <>
                <div className="input-section">
                  <input
                    type="file"
                    ref={fileInputRef}
                    multiple
                    onChange={handleFileUpload}
                    style={{ display: "none" }}
                    accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,image/*"
                  />
                  <input
                    type="file"
                    ref={imageInputRef}
                    multiple
                    onChange={handleImageUpload}
                    style={{ display: "none" }}
                    accept="image/*"
                  />

                  <div className="input-wrapper">
                    {/* Text Input - Center */}
                    <textarea
                      ref={textareaRef}
                      placeholder={getPlaceholderText()}
                      value={message || ""}
                      onChange={handleTextareaChange}
                      onKeyPress={handleKeyPress}
                      className={`chat-input ${hasStartedChatting ? "chat-active-input" : ""}`}
                      rows="1"
                    />

                    {/* Attach Button - Left */}
                    <div className="attach-wrapper" ref={attachDropdownRef}>
                      <button
                        className={`attach-btn ${showAttachDropdown ? "active" : ""}`}
                        onClick={handleAttachClick}
                        onMouseEnter={() => setShowAttachText(true)}
                        onMouseLeave={() => setShowAttachText(false)}
                        ref={attachBtnRef}
                      >
                        <Plus size={20} className="attach-icon" />
                        <span
                          className={`attach-text ${showAttachText ? "visible" : ""}`}
                        >
                          Attach
                        </span>
                      </button>

                      {showAttachDropdown && (
                        <div className="attach-dropdown">
                          <div
                            className="attach-dropdown-item"
                            onClick={handleAttachFileClick}
                          >
                            <FileUp size={18} />
                            <span>Attach file</span>
                          </div>
                          <div
                            className="attach-dropdown-item"
                            onClick={handleAttachImageClick}
                          >
                            <Image size={18} />
                            <span>Add photo</span>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Action Buttons - Right (Mic & Send) */}
                    <div className="action-buttons">
                      <button
                        className={`mic-btn ${isRecording ? "recording" : ""}`}
                        onClick={toggleRecording}
                        title={isRecording ? "Stop recording" : "Start voice input"}
                      >
                        {isRecording ? <MicOff size={18} /> : <Mic size={18} />}
                      </button>

                      <button
                        className="send-icon-btn"
                        onClick={() => handleSend()}
                        disabled={!isSendEnabled()}
                        title="Send message"
                      >
                        <Send size={18} />
                      </button>
                    </div>
                  </div>
                </div>

                <div className={`warning-box-fused environment-${environment}`}>
                  <AlertCircle className="warning-icon" size={20} />
                  <span className="warning-text">{getWarningMessage()}</span>
                </div>
              </>
            )}

            {/* For TEA AI in chat active state, show a message if needed */}
            {isTEAIMode() && !shouldShowInputField() && (
              <div className="tea-mode-chat-active">
                <div className={`warning-box-fused environment-${environment}`}>
                  <AlertCircle className="warning-icon" size={20} />
                  <span className="warning-text">{getWarningMessage()}</span>
                </div>
              </div>
            )}
          </>
        )}

        {showMobileMenu && (
          <div
            className="mobile-menu-overlay"
            onClick={() => setShowMobileMenu(false)}
          >
            <div
              className="mobile-menu-content"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="mobile-menu-header">
                <h3>Menu</h3>
                <button
                  className="close-menu-btn"
                  onClick={() => setShowMobileMenu(false)}
                >
                  <X size={18} />
                </button>
              </div>
              <div className="mobile-menu-items">
                <button
                  className="mobile-menu-item"
                  onClick={() => {
                    handleEnvironmentBack();
                    setShowMobileMenu(false);
                  }}
                >
                  <MessageSquare size={18} /> Back to Chat
                </button>
                <button
                  className="mobile-menu-item"
                  onClick={() => {
                    onNavigate("documentSearch");
                    setShowMobileMenu(false);
                  }}
                >
                  <Search size={18} /> Document Search
                </button>
                <button
                  className="mobile-menu-item"
                  onClick={() => {
                    onNavigate("metadataExtractor");
                    setShowMobileMenu(false);
                  }}
                >
                  <Database size={18} /> Metadata Extractor
                </button>
                <button
                  className="mobile-menu-item"
                  onClick={() => {
                    onNavigate("exportData");
                    setShowMobileMenu(false);
                  }}
                >
                  <Download size={18} /> Export Data
                </button>
                <button
                  className="mobile-menu-item"
                  onClick={() => {
                    clearChat();
                    setShowMobileMenu(false);
                  }}
                >
                  <X size={18} /> Clear Chat
                </button>
                <button
                  className="mobile-menu-item"
                  onClick={() => {
                    onSettingsClick();
                    setShowMobileMenu(false);
                  }}
                >
                  <Settings size={18} /> Settings
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Floating Support Button */}
        <a
          href="https://nlng.4me.com/self-service/requests/new/provide_description?from=wizard&service_id=55763&service_instance_id=352900&template_id=160942&subject=Swift%20Vetter%20Support%20Request"
          target="_blank"
          rel="noopener noreferrer"
          className="floating-support-btn"
          title="Get Support"
        >
          <HelpCircle size={24} />
        </a>
      </div>
    </div>
  );
};
export default ChatContainer;